import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { envSwitch } from 'utils/envUtils';
import BannerView from 'pages/main_lobby/BannerTemplateSwitch';
import { APP, ENABLED_FEATURES, EVENT_BANNERS } from 'appenv';
import { useSelector } from 'react-redux';
import { BannerPosition, selectBannersByPosition } from 'models/banners';
import BackgroundImage from 'pages/landing/templates/Landing707Template/BackgroundImage';
import Apps from 'apps';

const RootContainer = styled.div`
  max-height: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  background: #DADBDE;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  width: 100%;
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`;

const BannerLink = styled.a`
  position: absolute;
  left: ${({ left }) => left}%;
  top: ${({ top }) => top}%;
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}%;
  transform: ${({ skewX, skewY }) => `skewX(${skewX}deg) skewY(${skewY}deg)`};
  display: block;
  text-decoration: none;
`;

const BannerRouteLink = styled(Link)`
  position: absolute;
  left: ${({ left }) => left}%;
  top: ${({ top }) => top}%;
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}%;
  transform: ${({ skewX, skewY }) => `skewX(${skewX ?? 0}deg) skewY(${skewY ?? 0}deg)`} translate(-50%,-50%);
  display: block;
  text-decoration: none;
`;

const InnerVideo = styled.video`
  position: absolute;
  left: ${({ left }) => left}%;
  top: ${({ top }) => top}%;
  width: auto;
  height: ${({ height }) => height}%;
  transform: translateX(-50%)
`;

const MiddleBanner = styled(BannerView)`
  position: absolute;
  left: ${({ left }) => left}%;
  top: ${({ top }) => top}%;
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}%;
  flex: 1 0 auto;
  transform: translateX(-50%)
`;

const StyledBackgroundImage = styled.img`
  width: 100%;
`;

const DesktopFancyLobbyViewTemplate = () => {
  const backgroundVideoSrc = envSwitch([
    [Apps.PicoX707, 'https://contents-virtual.eventxtra.com/uploads/vxevents_staging/originals/eba43b18-9d7d-494a-9aa4-0f4039b2339a.mp4'],
  ], null);

  const backgroundPreviewSrc = envSwitch([
    [Apps.PicoX707, 'https://contents-virtual.eventxtra.com/uploads/vxevents_staging/originals/c84fe0a6-a25d-4afb-adc3-f4abe5b0a3bb.jpeg'],
  ], null);

  const clickableLinks = envSwitch([
    ['picox707', [
      {
        to: 'hall',
        width: 20,
        height: 40,
        left: 27,
        top: 35,
      },
      {
        to: 'webinar',
        width: 20,
        height: 40,
        left: 73,
        top: 35,
      },
    ]],
  ], []);

  const middleBanners = useSelector(selectBannersByPosition(BannerPosition.middle));

  const autoPlay = envSwitch([],
    { left: true, middle: true, right: true });

  return (
    <RootContainer>
      <ContentContainer>
        {backgroundPreviewSrc && <StyledBackgroundImage src={backgroundPreviewSrc} />}
        {
          backgroundVideoSrc && (
            <BackgroundVideo autoPlay loop muted playsinline>
              <source src={backgroundVideoSrc} type="video/mp4" />
            </BackgroundVideo>
          )
        }

        <MiddleBanner
          height={20}
          left={50}
          top={20}
          width={40}
          assets={ENABLED_FEATURES.cmsBanner && middleBanners?.length > 0 ? middleBanners : EVENT_BANNERS.middle}
          autoPlay={autoPlay.middle}
        />

        {
          clickableLinks.map((link) => (
            <BannerRouteLink {...link} />
          ))
        }
      </ContentContainer>
    </RootContainer>
  );
};

export default DesktopFancyLobbyViewTemplate;
